import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putPlantLevelConfigSlice = createApi(`PutPlantLevelConfigSlice`,"PUT");

const PutPlantLevelConfigSlice = createSlice({
  name: 'PutPlantLevelConfigSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putPlantLevelConfigSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putPlantLevelConfigSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putPlantLevelConfigSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PutPlantLevelConfigSlice.reducer;